export default {
  // logo_text: '企业管理台',
  // sidebar_index: '首页',
  // sidebar_auth: '用户',
  // sidebar_crm: '客户',
  // sidebar_sys: '系统'
  qc_title: '质检'
}
